<template>
    <v-card
        flat
        v-if="contentSettings.length !==0"
        class=""
    >
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <!--- General Email Settings -->
        <v-container container--fluid class="onboarding-emails signup-container pb-12">
            <v-card-text class="tab-title">
                <p class="subtitle-editor">General email settings</p>
            </v-card-text>
            <v-divider class="emails-divider"></v-divider>

            <v-layout v-for="(i, index) in contentSettings" :key="index">
                <v-flex d-flex xs12 sm3>
                    <v-card-text v-if="i.type !== 'send_welcome_email'" class="bold-text tab-title">{{removeUnderScore(i.type)}}</v-card-text>
                    <v-card-text v-else class="bold-text tab-title">{{i.label}}</v-card-text>
                </v-flex>
                <v-flex d-flex xs12 sm9>
                    <v-card-text class="text-filed">
                        <v-text-field
                            v-if="i.type !== 'send_welcome_email'"
                            v-model="preparedData[i.type]"
                            single-line
                            :hint="i.hint"
                            persistent-hint
                            :error-messages="errors($v.preparedData[i.type])"
                            @blur="$v.preparedData[i.type].$touch()"
                        >
                        </v-text-field>
                        <v-switch
                            v-else
                            label=""
                            v-model="preparedData[i.type]"
                            true-value="1"
                            false-value="0"
                        ></v-switch>
                    </v-card-text>
                </v-flex>
            </v-layout>
            <v-alert
                class="pa-2 mt-4 text-left"
                :value="$v.preparedData.$error"
                outlined
                color="error"
                icon="priority_high"
                transition="scale-transition"
            >
                    <span class="caption">Please fill out form correctly.</span>
            </v-alert>
            <v-btn
                    :color="saveButtonSettings.color"
                    class="btns-onboard"
                    type="submit"
                    @click.native="putSettingsContent"
                    :loading="saveButtonSettings.loading"
                    :disabled="saveButtonSettings.loading"
                    transition="fade-transition">
                {{saveButtonSettings.text}}
            </v-btn>
        </v-container>
    </v-card>
    <v-card flat v-else>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-container v-if="loading == false" class="empty-container"></v-container>
    </v-card>
</template>


<script>
    import { VueEditor } from 'vue2-quill-editor';
    import ApiService from "@/common/api.service";
    import { validationMixin } from "vuelidate";
    import { required, email, maxLength } from "vuelidate/lib/validators";
    import { valMessages, getValMessage } from "@/common/error-messages";

    let validations = {
        preparedData: {
            reply_to_name: { required, txtMaxLen: maxLength(20) },
            reply_to_email_address: { email },
            send_welcome_email: {}
        }
    }

    export default {
        name: 'EmailSettings',
        props: ['orgid'],
        components: {
            VueEditor
        },
        mixins: [validationMixin],
        validations,
        data() {
            return {
                model: '',
                loading: true,
                contentSettings: [],
                preparedData: {},
                saveButtonSettings: {
                    color: "cyan darken-3",
                    text: 'Save Changes',
                    loading: false
                },
                savedButtons: [
                    {color: "cyan darken-3", text: 'Save Changes', loading: false},
                    {color: "cyan darken-3", text: 'Save Changes', loading: false},
                    {color: "cyan darken-3", text: 'Save Changes', loading: false}
                ],
                customToolbar: [
                    ['bold', 'italic', 'underline', 'link'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }]
                ],
            }
        },
        beforeMount() {
            this.getSettingsContent();
        },
        methods: {
            getSettingsContent() {
                ApiService.get(`/client_on_boarding_setup/email_settings/${this.orgid}`)
                    .then(response => {
                        let contentSettings = response.data.email_settings
                        let preparedData = {}

                        contentSettings.forEach(i => {
                            preparedData[i.type] = i.value
                            i.organization_form_id = this.orgid
                            if(i.type === "reply_to_name") {
                                i.hint = "If longer than 20 characters, try to list the most important words at the beginning."
                            } else if (i.type === "reply_to_email_address") {
                               i.hint = "Try to list an email which you check at least once every 4 business hours." 
                            } else if (i.type === 'send_welcome_email') {
                                i.label = "Autosend Login Info to New Clients"
                            }
                        })
                        this.contentSettings = contentSettings
                        this.preparedData = preparedData
                        this.loading = false;
                    })
                    .catch(error => {
                        this.error = error;
                    });
            },
            putSettingsContent() {
                this.$v.preparedData.$touch();
                if (!this.$v.preparedData.$invalid) {
                    this.saveButtonSettings.loading = true
                    let body = _.cloneDeep(this.contentSettings)
                    body.forEach(i => {
                        i.value = this.preparedData[i.type]
                    })

                    ApiService.put(`/client_on_boarding_setup/email_settings`, body)
                        .then(response => {
                            this.saveButtonSettings = {
                                color: 'success',
                                text: 'Changes Saved',
                                loading: false
                            }
                            setTimeout(() => {
                                this.saveButtonSettings = {
                                    color: "cyan darken-3",
                                    text: 'Save Changes',
                                    loading: false
                                }
                            }, 3000);
                        })
                        .catch(error => {
                            this.saveButtonSettings = {
                                color: "red",
                                text: 'Save Unsuccessful',
                                loading: false
                            }
                            setTimeout(() => {
                                this.saveButtonSettings = {
                                    color: "cyan darken-3",
                                    text: 'Save Changes',
                                    loading: false
                                }
                            }, 5000);
                        });
                }
            },
            putTemplateContent(type, subject, body, index) {
                this.savedButtons[index].loading = true;
                let data = {
                    type: type,
                    subject: subject,
                    body: body,
                    organization_form_id: this.orgid
                };
                ApiService.put('/client_on_boarding_setup/email_template', data)
                    .then(response => {
                        this.savedButtons[index].color = "success";
                        this.savedButtons[index].text = "Changes Saved";
                        this.savedButtons[index].loading = false;

                        setTimeout(() => {
                            this.savedButtons[index].color = "cyan darken-3";
                            this.savedButtons[index].text = "Save Changes";
                            this.savedButtons[index].loading = false;
                        }, 3000);
                    })
                    .catch(error => {
                        this.savedButtons[index].color = "red";
                        this.savedButtons[index].text = "Save Unsuccessful";
                        this.savedButtons[index].loading = false;
                        setTimeout(() => {
                            this.savedButtons[index].color = "cyan darken-3";
                            this.savedButtons[index].text = "Save Changes";
                            this.savedButtons[index].loading = false
                        }, 5000);
                    });
            },
            removeUnderScore(str) {
               return _.upperFirst(str.replace(/_/g, ' '));
            },
            errors: getValMessage(valMessages)(validations)
        }
    }
</script>
<style>
    .empty-container {
        padding: 0px;
    }

    .admin-btn-save {
        margin-bottom: 70px;
    }
</style>
